/**
 * Model that corresponds to the Lead model in hybris.
 */
import {Address, CmsComponent, Country, Region, User} from '@spartacus/core';

export interface LeadFormAddressMap {
  LC: LeadFormCreatorModel;
  LTCP: LeadFormCreatorModel;
  LTAC: LeadFormAddressModel;
}

export interface LeadFormCampaignDataModel {
  type?: string;
  value?: string;
}

export class LeadFormModel {

  constructor(
    // Sent to the backend
    public addresses?: LeadFormCreatorModel[] | LeadFormAddressModel[],
    // Collects the data from the form and will be converted to the addresses array
    public addressesMap: LeadFormAddressMap = {
      // Will be provided by the identity provider
      LC: new LeadFormCreatorModel(),
      // Will be provided by the user in the form
      LTCP: new LeadFormCreatorModel(),
      // Will be provided by the user in the form
      LTAC: new LeadFormAddressModel()
    },
    public comment?: string,
    public productCode?: string,
    public transactionTypeCode?: string,
    public data?: [LeadFormCampaignDataModel | LeadFormDataJsonModel]
  ) {
  }
}

export class LeadFormUserDataModel {
  constructor(
    public scimUserId?: string,
  ) {
  }
}

export class GoogleCaptchaDataModel {
  constructor(
    public cToken?: string
  ) {
  }
}

export class LeadFormContractDataModel {
  constructor(
    public sapCustomerID?: string,
    public totalRevenue?: string,
    public currency?: string,
    public contractStartDate?: string,
    public contractEndDate?: string,
    public materialID?: string,
    public entitlementId?: string,
  ) {
  }
}

export class LeadFormDataJsonModel {
  type?: string;
  value?: string;
}

export class LeadFormAddressModel implements Address {
  constructor(
    public addressUsage?: string,
    public companyName?: string,
    public country: LeadFormCountryModel = new LeadFormCountryModel(),
    public defaultAddress?: boolean,
    public district?: string,
    public formattedAddress?: string,
    public id?: string,
    public line1?: string,
    public line2?: string,
    public phone?: string,
    public postalCode?: string,
    public region?: Region,
    public regionIsocodeArray?: string[],
    public shippingAddress?: boolean,
    public title?: string,
    public titleCode?: string,
    public town?: string,
    public visibleInAddressBook?: boolean
  ) {
  }
}

export interface LeadFormCreator extends User {
  id?: string;
  phone?: string;
  email?: string;
  scimUserId?: string;
}

export class LeadFormCreatorModel implements LeadFormCreator {
  constructor(
    public id?: string,
    public customerId?: string,
    public displayUid?: string,
    public firstName?: string,
    public lastName?: string,
    public name?: string,
    public addressUsage?: string,
    public cellphone?: string,
    public phone?: string,
    public email?: string,
    public title?: string,
    public titleCode?: string,
    public visibleInAddressBook?: boolean,
    public defaultAddress?: Address,
    public defaultUnitAddress?: Address
  ) {
  }
}

export class LeadFormCountryModel implements Country {
  constructor(
    public isocode?: string,
    public name?: string) {
  }
}

export class LeadFormRegionModel implements Region {


  constructor(
    public countryIso?: string,
    public isocode?: string,
    public isocodeShort?: string,
    public name?: string,
  ) {
  }
}

export interface DcpUserDomain extends CmsComponent {
  listOfEmployeeDomains: Array<string>;
}
